<template lang="pug">
    div(
        class="full-width"
        :key="linkId"
    )
        v-layout(wrap ma-2)
            v-flex.mt-3.mb-6(xs12)
                v-layout.wf-space-between( column class="summary" )
                    span#summary-customer-name Customer: {{ customerName }}
                    span#summary-amount.pr-3 $ {{ paymentAmount }}
                v-layout(class="payment-link-activity")
                    // Creating Loop for Activities Array
                    span(v-html="expirationDate")

                v-layout(v-if="submitted" class="transaction-id")
                    p#summary-transaction #[strong Transaction ID: ]
                        span#span-transaction-id {{ transactionId }}

                v-flex#status-body.mt-3.mb-3(xs12)
                    //Activity
                    v-flex.text-xs-left.title.mt-2
                        v-expansion-panel.custom(
                            v-if="activity && activity.length > 1"
                            inset
                        )
                            v-expansion-panel-content
                                div(slot="header")
                                    span(v-html="getActivity(activity[0]['name'])")
                                    |  on {{ formatEpochToString(activity[0]['at']) }}
                                v-card
                                v-card-text
                                    ul.pl-3
                                    li.grey--text(
                                        v-for="event in activity.slice(1)"
                                    )
                                        p
                                        span(v-html="getActivity(event['name'])")
                                        |  on {{ formatEpochToString(event['at']) }}
                        div(v-else-if="activity && activity.length === 1")
                            span(v-html="getActivity(activity[0]['name'])")
                                |  on {{ formatEpochToString(activity[0]['at']) }}
                        
            v-flex
                v-layout(row justify-end wrap)
                    v-btn#copy-link-btn.mr-0(
                        v-if="!expired && !submitted"
                        flat
                        :color="clicked ? 'success' : 'secondary'"  
                        @click = "copyLink"
                    )
                        v-icon.pr-1(v-if="clicked") mdi-check
                        |    {{ clicked ? 'Copied' : 'Copy Link'}}
        v-divider            
</template>

<script>
    import { delayMilliseconds } from 'Helpers/utilFunctions.js'
    import { differenceInHours } from "date-fns"
    import { numberWithCommas } from "@/helpers/parsingFunctions"
    
    export default {
        name: "payment-links-list-tile",
        props: {
            linkId: String,
            activity: Array,
            amount: Number,
            companyName: String,
            createdAt: Number,
            creator: String,
            customerName: String,
            dealerId: String,
            description: String,
            expiresAt: Number,
            href: String,
            status: String,
            transactionId: String,
        },
        data: () => ({
            clicked: null,
        }),
        computed: {
            hoursToExpire() {
                return differenceInHours( new Date(this.expiresAt), new Date())
            },
            expired() {
                return this.hoursToExpire < 0
            },
            expirationDate() {
                return `<strong>${ !this.expired ? 'Expires on:' : 'Expired on:' }</strong> ${new Date(this.expiresAt).toLocaleString()}`
            },
            paymentAmount() {
                return this.amount ? numberWithCommas(this.amount.toFixed(2)) : ''
            },
            submitted() {
                return this.status === "Submitted"
            }
        },
        methods: {
            async copyLink() {
                await navigator.clipboard.writeText(this.href)
                this.clicked = true
                await delayMilliseconds(1000)
                this.clicked = false
            },
            formatEpochToString(date) {
                return new Date(date).toLocaleString().replace(', ', ' at ')
            },
            getActivity(name) {
                return (name === "Opened")
                ? `${this.customerName} <span class="green--text">opened</span>`
                    : (name === "Sent")
                ? `${this.companyName} <span class="green--text">sent</span>`
                    : (name === "Created")
                ? `${this.companyName} <span class="green--text">created</span> a payment request for $${this.paymentAmount}`
                    : (name === "Submitted")
                ? `${this.customerName} <span class="green--text">submitted</span> a payment for $${this.paymentAmount}`
                : null
            },
        },
    }
</script>

<style lang="scss" scoped>
    .summary {
        font-size: 15px;
        font-weight: bold;
    }

    .payment-link-activity {
        font-size: 12px;
        text-align: left;
    }

    .transaction-id {
        justify-content: center;
    }

    .custom.v-expansion-panel--inset .v-expansion-panel__container {
    max-width: 100%!important;

    &.v-expansion-panel__container--active {
            box-shadow: none;
        }
    }

    button::v-deep .v-btn--disabled {
        color: red !important;
    }
</style>